<template>
	<transition name="modal-fade">
		<div
			v-show="visible"
			:aria-hidden="!visible"
			:style="wrapperStyle"
			class="fixed inset-0 flex items-center justify-center px-4 py-6"
			style="z-index: 9999"
		>
			<div
				class="absolute inset-0 bg-black/50 backdrop-blur-sm"
				@click="emitClose"
			/>
			<div
				:class="['relative w-full mx-auto', contentClass]"
				role="dialog"
				aria-modal="true"
				tabindex="0"
			>
				<div
					class="bg-white rounded-xl shadow-2xl overflow-hidden border border-border"
				>
					<header
						class="flex items-center justify-between px-6 py-4 bg-primary text-white"
					>
						<div class="text-lg font-semibold">{{ title }}</div>
						<button
							@click="emitClose"
							class="inline-flex items-center justify-center w-9 h-9 rounded-md bg-white/10 hover:bg-white/20"
						>
							<svg
								class="w-4 h-4"
								viewBox="0 0 24 24"
								fill="none"
								stroke="currentColor"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M6 18L18 6M6 6l12 12"
								/>
							</svg>
						</button>
					</header>
					<div class="p-6 bg-surface">
						<slot name="content">
							<slot />
						</slot>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: 'CenteredModal',
	props: {
		show: { type: Boolean, default: false },
		title: { type: String, default: '' },
		content_class: { type: String, default: '' },
	},
	computed: {
		contentClass() {
			return this.content_class || 'max-w-3xl';
		},
		visible() {
			return !!this.show;
		},
		wrapperStyle() {
			return { zIndex: 9999, display: this.visible ? 'flex' : 'none' };
		},
	},
	methods: {
		emitClose() {
			this.$emit('close');
		},
		onKeyDown(e) {
			if (e.key === 'Escape' || e.key === 'Esc') this.emitClose();
		},
	},
	mounted() {
		console.log('CenteredModal mounted, show=', this.show);
		if (this.show) {
			document.addEventListener('keydown', this.onKeyDown);
			document.body.style.overflow = 'hidden';
			this.$emit('opened');
		}
	},
	watch: {
		show(val) {
			console.log('CenteredModal show changed to', val);
			if (val) this.$emit('opened');
			if (val) {
				document.addEventListener('keydown', this.onKeyDown);
				document.body.style.overflow = 'hidden';
			} else {
				document.removeEventListener('keydown', this.onKeyDown);
				document.body.style.overflow = '';
				try {
					const el =
						this.$el &&
						this.$el.querySelector &&
						this.$el.querySelector('[tabindex]');
					if (el) el.blur();
				} catch (e) {}
			}
		},
	},
	beforeDestroy() {
		document.removeEventListener('keydown', this.onKeyDown);
		document.body.style.overflow = '';
	},
};
</script>

<style scoped>
.modal-fade-enter-active,
.modal-fade-leave-active {
	transition: opacity 200ms ease;
}
.modal-fade-enter-from,
.modal-fade-leave-to {
	opacity: 0;
}
.bg-surface {
	background-color: #ffffff;
}
.border-border {
	border-color: rgba(0, 0, 0, 0.06);
}
.bg-primary {
	background-color: #1d4ed8;
}
</style>
